import React from 'react';
const ProblemV2 = ({ copy }) => {
  if (!copy) return null;
  return (
    <section className="iv2-problem" data-testid="iv2-problem">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline" data-testid="iv2-problem-headline">
          {copy.headline} <span className="iv2-emphasis">{copy.emphasis}</span>
        </h2>
        <p className="iv2-problem-body" data-testid="iv2-problem-body">{copy.body}</p>
      </div>
    </section>
  );
};
export default ProblemV2;
